// import { useEffect, useState } from "react";
// import { fetchPageBySlug } from "../../api/axios";
// import DynamicBreadcrumb from "../common/DynamicBreadcrumb";
// import RichText from "../sections/RichText";
// import Seo from "../_App/seo";
// import { useParams } from "react-router-dom";

// const LegalPage = () => {
//   const { slug } = useParams();
//   const [pageData, setPageData] = useState(null);

//   const componentMap = {
//     "sections.content-editor": RichText,
//   };

//   useEffect(() => {
//     fetchPageBySlug(slug).then((data) => {
//       setPageData(data);
//     });
//   }, [slug]);

//   return (
//     <>
//       {pageData && (
//         <Seo
//           seo={pageData?.seo}
//           slug={pageData?.slug}
//         />
//       )}

//       <DynamicBreadcrumb />

//       {pageData?.sections?.map((section) => {
//         const SectionComponent = componentMap[section.__component];

//         return SectionComponent ? (
//           <SectionComponent key={section.id} data={section} />
//         ) : null;
//       })}
//     </>
//   );
// };

// export default LegalPage;

import { useEffect, useState } from "react";
import { fetchPageBySlug } from "../../api/axios";
import DynamicBreadcrumb from "../common/DynamicBreadcrumb";
import RichText from "../sections/RichText";
import Seo from "../_App/seo";
import { useParams } from "react-router-dom";
import NotFound from "../../pages/NotFound";

const LegalPage = () => {
  const { slug } = useParams();

  const [pageData, setPageData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [loading, setLoading] = useState(true);

  const componentMap = {
    "sections.content-editor": RichText,
  };

  // useEffect(() => {
  //   setLoading(true);
  //   setNotFound(false);

  //   fetchPageBySlug(slug)
  //     .then((res) => {
  //       if (!res || res.length === 0) {
  //         setNotFound(true);
  //       } else {
  //         setPageData(res[0]);
  //       }
  //     })
  //     .catch(() => {
  //       setNotFound(true);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }, [slug]);

  useEffect(() => {
  setLoading(true);
  setNotFound(false);

  fetchPageBySlug(slug)
    .then((page) => {
      console.log("Fetched Page:", page);

      if (!page) {
        setNotFound(true);
      } else {
        setPageData(page);
      }
    })
    .catch((err) => {
      console.error("Error fetching page:", err);
      setNotFound(true);
    })
    .finally(() => {
      setLoading(false);
    });
}, [slug]);

  if (loading) return null; // or loader
  if (notFound) return <NotFound />;

  return (
    <>
      {pageData && (
        <Seo
          seo={pageData?.seo}
          slug={pageData?.slug}
        />
      )}

      <DynamicBreadcrumb />

      {pageData?.sections?.map((section) => {
        const SectionComponent = componentMap[section.__component];
        return SectionComponent ? (
          <SectionComponent key={section.id} data={section} />
        ) : null;
      })}
    </>
  );
};

export default LegalPage;